import script from "./ChatNewDialogButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatNewDialogButton.vue?vue&type=script&setup=true&lang=js"

import "./ChatNewDialogButton.vue?vue&type=style&index=0&id=12380bf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12380bf6"]])

export default __exports__